import { render, staticRenderFns } from "./Parametros.vue?vue&type=template&id=b95eebac"
import script from "./Parametros.vue?vue&type=script&lang=js"
export * from "./Parametros.vue?vue&type=script&lang=js"
import style0 from "./Parametros.vue?vue&type=style&index=0&id=b95eebac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports